// window.location.origin is [LegacyUnforgeable] per the WHATWG spec, so it can't be
// mocked in a spec-compliant environment (real browser, or jsdom since Jest 30) — accept
// it as an optional override instead, same pattern used for navigation in RemocalWidget.
export const shouldShowRemocalWidget = (origin: string = window.location.origin): boolean => {
  return /prcom\d+\.junipersquare\.us$/.test(origin);
};
